import { UserRole, Permission } from '../types/auth'

const ROLE_PERMISSIONS: Record<UserRole, Permission[]> = {
  OWNER: [
    'manage_users',
    'manage_teams',
    'manage_locations', 
    'manage_schedules',
    'manage_timesheets',
    'manage_reports',
    'manage_settings',
    'view_audit_logs',
    'manage_roles',
    'clock_in_out',
    'view_own_timesheet',
    'request_pto',
    'view_own_schedule',
  ],
  ADMIN: [
    'manage_users',
    'manage_teams',
    'manage_locations', 
    'manage_schedules',
    'manage_timesheets',
    'manage_reports',
    'manage_settings',
    'view_audit_logs',
    'manage_roles',
    'clock_in_out',
    'view_own_timesheet',
    'request_pto',
    'view_own_schedule',
  ],
  TEAM_ADMIN: [
    'manage_users',
    'manage_schedules',
    'manage_timesheets',
    'manage_reports',
    'view_audit_logs',
    'clock_in_out',
    'view_own_timesheet',
    'request_pto',
    'view_own_schedule',
  ],
  MEMBER: [
    'clock_in_out',
    'view_own_timesheet',
    'request_pto', 
    'view_own_schedule',
  ],
}

export function hasPermission(role: UserRole, permission: Permission): boolean {
  return ROLE_PERMISSIONS[role].includes(permission)
}

export function getRolePermissions(role: UserRole): Permission[] {
  return ROLE_PERMISSIONS[role]
}

export function canManageUser(userRole: UserRole): boolean {
  if (userRole === 'OWNER') return true
  if (userRole === 'ADMIN') return true
  if (userRole === 'TEAM_ADMIN') return true
  return false
}

export function canAccessTeamData(userRole: UserRole, userTeamId: string, targetTeamId: string): boolean {
  if (userRole === 'OWNER') return true
  if (userRole === 'ADMIN') return true
  // Team admins and members can only access their own team
  return userTeamId === targetTeamId
}